import { useRef } from 'react';
import { WidgetContainer } from '@/components/analytics/WidgetContainer';
import { BarChart } from '@/components/analytics/charts/BarChart';
import { useChartDimensions } from '@/hooks/useChartDimensions';
import type { TimeDistributionData } from '@/types/analytics';
import styles from './TimeDistributionWidget.module.scss';

export interface TimeDistributionWidgetProps {
    data: TimeDistributionData[] | null;
    isLoading?: boolean;
    error?: Error | null;
}

export function TimeDistributionWidget({ data, isLoading, error }: TimeDistributionWidgetProps) {
    const containerRef = useRef<HTMLDivElement>(null);
    const { width } = useChartDimensions(containerRef as any);

    const isEmpty = !data || data.length === 0;

    // Format data for chart (0-23 hours)
    const chartData = data
        ? data.map((d) => ({
            label: `${d.hour}:00`,
            value: d.questionCount,
            color: 'var(--primary)',
        }))
        : [];

    return (
        <WidgetContainer
            title="Time Distribution"
            description="Activity by hour of day"
            isLoading={isLoading}
            error={error}
            isEmpty={isEmpty}
            emptyMessage="Practice more to see time patterns"
            size="medium"
        >
            <div ref={containerRef} className={styles.container}>
                {width > 0 && (
                    <BarChart
                        data={chartData}
                        width={width}
                        height={200}
                        animate
                        showValues={false}
                    />
                )}
            </div>
        </WidgetContainer>
    );
}
